<section class="project-wizard-contact-help">
  <div class="project-wizard-contact-help__intro">
    <h3 class="project-wizard-contact-help__title">
      {{ "projectWizard.contactHelp.title" | translate }}
    </h3>
    <p class="project-wizard-contact-help__description">
      {{ "projectWizard.contactHelp.description" | translate }}
    </p>
  </div>
  <hr class="project-wizard-contact-help__rule" />
  @if (loadingContact()) {
  <div class="project-wizard-contact-help__contact-row">
    <div
      class="spinner-border spinner-border-sm text-primary project-wizard-contact-help__spinner"
      role="status"
    ></div>
  </div>
  } @else {
  <div class="project-wizard-contact-help__contact-row">
    <div class="project-wizard-contact-help__contact-text">
      <div class="project-wizard-contact-help__name">{{ contactName() }}</div>
      <div class="project-wizard-contact-help__phone">{{ phoneLine() }}</div>
      <div class="project-wizard-contact-help__email-line">
        @if (emailLine(); as em) {
        <a class="project-wizard-contact-help__email" [href]="'mailto:' + em">{{
          em
        }}</a>
        } @else {
        <span class="project-wizard-contact-help__email-fallback">-</span>
        }
      </div>
    </div>
  </div>
  }
</section>
